export default __webpack_public_path__ + "static/b39a0bc14c00d9cd49ebb3fb3d6aebd7.jpeg";